import React, { AnchorHTMLAttributes } from 'react';
import styles from './Link.module.css';

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  underline?: boolean;
}

const Link: React.FC<LinkProps> = ({
  underline = true,
  className = '',
  children,
  ...rest
}) => {
  const classes = [
    styles.link,
    !underline ? styles['no-underline'] : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <a className={classes} {...rest}>
      {children}
    </a>
  );
};

export default Link;
